import React from 'react'
import TitleBar from '../../components/common-components/TitleBar'
import CustomButton from '../../components/common-components/CustomButton'
import { Box, Button } from '@mui/material'
import styled from 'styled-components'
import SinglememberForm from '../../components/taxfiling/SinglememberForm'

const SingleMember = () => {
  return (
    <>
      
      <SinglememberForm />
    </>
  )
}

export default SingleMember

export const StyleDiv = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 10px;
  
`

export const StyledSpan = styled.span`
  font-size: 12px;
  color: #6c6f71;
  font-weight: 600;
  background:rgb(223, 214, 214);
  padding: 5px 10px;
  border-radius: 5px;
`
const StyledButton = styled(Button)`
//    width: 120px;
                    borderRadius: 8px;
            fontSize: 14px;
            FontWeight: 500;
            boxShadow: none;
            whiteSpace: nowrap;
`